import { render } from "./ControlSheetsPage.vue?vue&type=template&id=76d07b12&ts=true"
import script from "./ControlSheetsPage.vue?vue&type=script&lang=ts"
export * from "./ControlSheetsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__